import type { ApiWsInplantFilter, WsInplantFilter } from "../../../../../api/wsInplants";

/** Приводит клиентский {@link WsInplantFilter} к API-форме для запроса списка. */
export function serializeWsInplantApiFilter(filter: WsInplantFilter): ApiWsInplantFilter {
    return {
        Codes: filter.Codes,
        Num: filter.Num,
        DocDate: filter.DocDate,
        SenderCodes: filter.SenderCodes,
        SenderSectionCodes: filter.SenderSectionCodes,
        ReceiverCodes: filter.ReceiverCodes,
        ReceiverSectionCodes: filter.ReceiverSectionCodes,
        LeaveMoveDate: filter.LeaveMoveDate,
        ArrivalMoveDate: filter.ArrivalMoveDate,
    };
}
